<div class="header-background">
  <button backButton mat-icon-button *ngIf="navigationService.backButton$ | async">
    <mat-icon>west</mat-icon>
  </button>
  <div class="logo">
      <app-logo></app-logo>
  </div>

  <div class="options" *ngIf="navigationService.options$ | async">
    <a mat-icon-button href="https://llamandoaldoctor.com/faqs_usuarios.html" target="_blank">
      <mat-icon svgIcon="questions"></mat-icon>
    </a>
    <button *ngIf="showSetting" (click)="showEvent()" mat-icon-button routerLink="{{'/'+settingsPath}}"
      routerLinkActive="active">
      <mat-icon svgIcon="settings"></mat-icon>
    </button>
  </div>
</div>
